var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRaisingMoneyCase3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 129,
    viewBox: "0 0 127 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1866_3041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 31.1047C10 19.4489 19.4489 10 31.1047 10H87.2758C98.9317 10 108.381 19.4489 108.381 31.1047V88.8953C108.381 100.551 98.9317 110 87.2758 110H31.1047C19.4489 110 10 100.551 10 88.8953V31.1047Z",
    fill: "#FBF8F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.6364 34.5909C84.1045 33.4773 80.2227 33 76.5 33C70.2955 33 63.6136 34.2727 59 37.7727C54.3864 34.2727 47.7045 33 41.5 33C35.2955 33 28.6136 34.2727 24 37.7727V84.3864C24 85.1818 24.7955 85.9773 25.5909 85.9773C25.9091 85.9773 26.0682 85.8182 26.3864 85.8182C30.6818 83.75 36.8864 82.3182 41.5 82.3182C47.7045 82.3182 54.3864 83.5909 59 87.0909C63.2955 84.3864 71.0909 82.3182 76.5 82.3182C81.75 82.3182 87.1591 83.2727 91.6136 85.6591C91.9318 85.8182 92.0909 85.8182 92.4091 85.8182C93.2045 85.8182 94 85.0227 94 84.2273V37.7727C92.0909 36.3409 90.0227 35.3864 87.6364 34.5909ZM87.6364 77.5455C84.1364 76.4318 80.3182 75.9545 76.5 75.9545C71.0909 75.9545 63.2955 78.0227 59 80.7273V44.1364C63.2955 41.4318 71.0909 39.3636 76.5 39.3636C80.3182 39.3636 84.1364 39.8409 87.6364 40.9545V77.5455Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1866_3041",
    x: 0.151122,
    y: 0.151122,
    width: 126.521,
    height: 128.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.03491,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1866_3041"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.22095,
    dy: 4.22095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1866_3041"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1866_3041",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaisingMoneyCase3);
export default __webpack_public_path__ + "static/media/RaisingMoneyCase3.f09e2228f8116c0119f99ee3b625c813.svg";
export { ForwardRef as ReactComponent };